import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xs uppercase" }

import { cn } from '@/lib/utils';
    import { computed, ref } from 'vue';
    import axios from 'axios';
    import Icon from '@/components/Icon.vue';
    import type { HTMLAttributes } from 'vue';
    import VueDatePicker from '@vuepic/vue-datepicker';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MonthPicker',
  props: {
    modelValue: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const date = ref({
        month: new Date(props.modelValue).getMonth(),
        year: new Date(props.modelValue).getFullYear(),
    });

    const month = computed(() => {
        return new Date(date.value.year, date.value.month).toLocaleString('da', {
            month: 'short',
        });
    });

    const handleDateUpdate = async (newDate: { month: number; year: number }) => {
        const formattedDate = `${newDate.year}-${String(newDate.month + 1).padStart(2, '0')}`;
        await axios.patch(route('v2.user.select-month'), {
            selected_month: formattedDate,
        });
        emit('update:modelValue', formattedDate);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueDatePicker), {
    modelValue: date.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
      handleDateUpdate
    ],
    "month-picker": "",
    "auto-apply": "",
    teleport: true,
    "action-row": { showSelect: false, showCancel: false },
    locale: "da",
    config: {
            modeHeight: 200,
        },
    transitions: {
            menuAppearBottom: 'dp-menu-appear',
        }
  }, {
    trigger: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(cn)('hover:text-accent flex cursor-pointer items-center gap-2', props.class))
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(month.value), 1),
        _createVNode(Icon, {
          name: "calendar",
          class: "size-4"
        })
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})